import { cn } from "@/lib/utils";

export function SurfaceCard({ children, className, dark = false, ...props }) {
  return (
    <div
      className={cn(
        "rounded-2xl border",
        dark
          ? "relative overflow-hidden border-[#223139] bg-[#0E1A21] text-white"
          : "border-[#E2E8F0] dark:border-[#223139] bg-white dark:bg-[#0E1A21]",
        className
      )}
      {...props}
    >
      {dark && <div className="contaha-grid absolute inset-0 opacity-20 pointer-events-none" />}
      <div className="relative">{children}</div>
    </div>
  );
}

export function MetricCard({ icon: Icon, label, value, hint, tone = "default", onClick, testId }) {
  const tones = {
    default: "text-[#00A85A] bg-[#E8F7F0] dark:bg-[#00A85A]/15",
    amber: "text-amber-500 bg-amber-50 dark:bg-amber-500/15",
    blue: "text-blue-500 bg-blue-50 dark:bg-blue-500/15",
    red: "text-red-500 bg-red-50 dark:bg-red-500/15",
  };
  return (
    <button
      type="button"
      onClick={onClick}
      data-testid={testId}
      className="group text-left w-full rounded-2xl border border-[#E2E8F0] dark:border-[#223139] bg-white dark:bg-[#0E1A21] p-5 transition-colors hover:border-[#00A85A]/40"
    >
      <div className="flex items-center justify-between">
        <div className={cn("flex h-10 w-10 items-center justify-center rounded-xl", tones[tone])}>
          {Icon && <Icon className="h-5 w-5" strokeWidth={2} />}
        </div>
        {onClick && (
          <span className="text-[#8B9698] opacity-0 transition-opacity group-hover:opacity-100 text-xs">→</span>
        )}
      </div>
      <div className="mt-4 text-3xl font-extrabold tracking-tight text-[#101516] dark:text-white tabular-nums">
        {value}
      </div>
      <div className="mt-1 text-[11px] font-bold uppercase tracking-wider text-[#8B9698]">{label}</div>
      {hint && <div className="mt-0.5 text-xs text-[#687173] dark:text-[#8B9698]">{hint}</div>}
    </button>
  );
}
